import _ from '@lodash';
import { Card, Checkbox, Radio, Tooltip, Typography, withStyles } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import * as Helpers from 'app/Core/Helpers';
import AgendamentoEdicaoApp from 'app/CRM/AgendamentoEdicao/AgendamentoEdicaoApp';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import React from 'react';
import { makeStyles } from "@material-ui/styles";

const styles = theme => ({
    borderColor: {
        borderColor: theme.palette.divider
    },
});

const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
});

function PessoaCard(props) {

    const { card, onChange, classes, listFilter } = props;

    if (!card) {
        return null;
    }

    return (
        <Card
            className={clsx("w-full mb-16 rounded-4 relative")}
            id={"card_" + card.idpessoaformulario}
        >
            <>
                <div className="flex w-full">
                    <Checkbox
                        name="selected"
                        checked={!_.isNull(card.idpessoaformulariorelacionamento)}
                        onClick={ev => ev.stopPropagation()}
                        onChange={ev => onChange(card)}
                    />
                    <div className="p-12 w-full">
                        <div className="flex flex-col md:flex-row">
                            <Typography className="font-600 flex items-center w-full md:w-1/3">{card.nome}</Typography>
                            {!_.isNull(card.formulario) &&
                                <>
                                    <Typography className="font-600 flex items-center w-full md:w-1/3">{formatter.format(card.formulario?.valor)}</Typography>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </>
        </Card>
    );
}

export default withStyles(styles, { withTheme: true })(PessoaCard);
